import { NavLink } from "react-router-dom";

import { Icon } from "@/components/Icon";
import { useAuth } from "@/lib/auth";

interface SidebarProps {
  onSignOut: () => void;
}

const NAV_ITEMS = [
  { to: "/dashboard",   label: "Dashboard",        icon: Icon.Grid },
  { to: "/map",         label: "Mapa",             icon: Icon.Map },
  { to: "/mountpoints", label: "Mountpoints",      icon: Icon.Radio },
  { to: "/clients",     label: "Clientes",         icon: Icon.Clients },
  { to: "/access",      label: "Accesos (ACL)",    icon: Icon.Key },
  { to: "/users",       label: "Administradores",  icon: Icon.Users },
];

function initials(name: string | null | undefined) {
  if (!name) return "··";
  return name
    .split(/\s+/)
    .map((s) => s[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

export function Sidebar({ onSignOut }: SidebarProps) {
  const { user } = useAuth();

  return (
    <aside className="nav">
      <div className="nav__brand">
        <img className="nav__wordmark" src="/assets/logo-amelia.png" alt="Amelia" />
        <div className="nav__title-row">
          <div className="nav__title">Caster Manager</div>
        </div>
        <div className="nav__sub">RTK Service</div>
        <div className="nav__coords">
          <span>04°42′40″N · 074°04′19″W</span>
          <span>NTRIP v2.0 · Caster activo</span>
        </div>
      </div>

      <nav className="nav__menu">
        <div className="nav__section-label">Operación</div>
        {NAV_ITEMS.map(({ to, label, icon: I }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `nav__item ${isActive ? "is-active" : ""}`
            }
          >
            <I />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="nav__foot">
        <div className="nav__user">
          <div className="nav__user-avatar">{initials(user?.name)}</div>
          <div className="nav__user-info">
            <div className="nav__user-name">{user?.name ?? "Caster Admin"}</div>
            <div className="nav__user-mail">{user?.email ?? "—"}</div>
          </div>
        </div>
        <button className="nav__signout" onClick={onSignOut}>
          <Icon.SignOut />
          <span>Cerrar sesión</span>
        </button>
      </div>
    </aside>
  );
}
